import PropTypes from "prop-types"
import React from "react"
import { Grid } from "semantic-ui-react"

const BifrostGridForm = ({ rows }) => {
	return (
		<Grid>
			{rows.map((row) => (
				<Grid.Row key={row.name}>
					{row.cells.map(
						(cell) =>
							(cell.renderCondition || cell.renderCondition === null) && (
								<Grid.Column key={cell.name} width={cell.width} color={cell.color}>
									{cell.content}
								</Grid.Column>
							)
					)}
				</Grid.Row>
			))}
		</Grid>
	)
}

BifrostGridForm.propTypes = {
	rows: PropTypes.arrayOf(
		PropTypes.shape({
			name: PropTypes.string,
			cells: PropTypes.arrayOf(
				PropTypes.shape({
					name: PropTypes.string,
					width: PropTypes.number, // 1-16
					renderCondition: PropTypes.bool,
					content: PropTypes.element
				})
			)
		})
	)
}

export default BifrostGridForm
